export default __webpack_public_path__ + "static/media/c4.20bff0ed.png";